import React from "react";

const ConnectSvg = () => {
  return (
    <svg
      width="29"
      height="29"
      viewBox="0 0 29 29"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="14.5" cy="14.5" r="14.5" fill="#35E136" />
      <path
        d="M9.74219 15.1797L12.9141 18.3516L19.2578 11.5547"
        stroke="white"
        strokeWidth="1.8125"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default ConnectSvg;
